import axios from 'axios'

const API_URL = "http://supportsoft.in/pizza/api";

const state = { 
   menu : [],
   sn: null,
   cat_name: null,
   cat_id: null,
   showPizzaSize: true,
   specials: []
 };
const actions = { 
    getMenu({commit}, payload) {
        return new Promise((resolve, reject) => {
            let cat_id = payload
            let url = API_URL+ '/menu?cat_id='+cat_id;
            axios.get(url).then(response => {
            let catData = response.data
            if(catData.length > 0){            
                var cat_name = catData[0].cat_name    
                var short_name = cat_name.charAt(0)
            }else{
                var cat_name = "No Data Available"
                var short_name = "N"
            }
            commit('updateMenuList', catData)
            commit('updateShortName', short_name)
            commit('updateCatName', cat_name)
            commit('updatePizzaSize', cat_id)
            commit('updateCatId', cat_id)
            resolve(catData);
            }).catch(err => {
                reject(err)
            }); 
        })
          
   },
   async specials({commit}, payload){
      let url = API_URL + '/all-specials';
      await axios.get(url).then(response => {
        let catData = response.data
        commit('setspecials', catData);
      });
   }
};
const mutations = {
    setspecials(state, payload){
        state.specials = payload
    },
    updateCatId(state, payload){
        state.cat_id = payload
    },
    updateMenuList(state, payload){
        state.menu = payload
    },
    updateShortName(state, payload){
        state.sn = payload
    },
    updateCatName(state, payload){
        state.cat_name = payload
    },
    updatePizzaSize(state, payload){
        if(payload == 1 || payload == 2){
            state.showPizzaSize = true
        }
        else{
            state.showPizzaSize = false
        }
    }
};
const getters = { 
    getMenu: (state) => state.menu,
    short_name: (state) => state.sn,
    cat_name: state => state.cat_name,
    cat_id: state => {
        
        if(state.cat_id === null){
            state.cat_id = 1
        }else{
            state.cat_id
        }
    },
    showPizzaSize: state => state.showPizzaSize,
    specials: state => state.specials
};
export default {
    state,
    actions,
    mutations,
    getters
};